import {
   useNavbarStore,
   NavItemModel
} from '@flowwai-frontend/bps-officer-web/navbar-base'

import useGetApplicationNavItemsData from './useGetApplicationNavItemsData'

const useGetApplicationNavItems = () => {
   const navbarStore = useNavbarStore()
   const applicationData = useGetApplicationNavItemsData()

   const setApplicationNavItems = (): void => {
      applicationData.forEach(item => {
         const { children, ...navItem } = item
         const navItemModel = NavItemModel.createNavItemModel(navItem)

         navbarStore.addApplicationNavItem(navItemModel)
         navbarStore.addNavItem(navItemModel)

         if (children) {
            children.forEach(child => {
               const childNavItem = NavItemModel.createNavItemModel(child)
               navItemModel.addChild(childNavItem)
               navbarStore.addNavItem(childNavItem)
            })
         }
      })
   }

   return { setApplicationNavItems }
}

export default useGetApplicationNavItems
